<div class="optimization-dialog">
  <div class="dialog-content">
    <div class="header-content">
      <div class="icon-container">
        <img src="assets/icons/inprograss-optimization.png" alt="Optimization in progress" class="optimization-icon">
      </div>
      <h2 class="dialog-title">Optimization In Progress</h2>
    </div>
    <div class="loading-bar-container">
      <div class="loading-bar"></div>
    </div>
  </div>
</div>

